export default "__VITE_ASSET__DzcjSZ5O__"